<template>
  <div class="number-grow-warp">
    <span ref="numberGrow" :data-time="time" class="number-grow" :data-value="value">0</span>
  </div>
</template>
<script>
export default {
  props: {
    time: {
      type: Number,
      default: 2
    },
    value: {
      type: Number,
      default: 720000
    }
  },
  methods: {
    numberGrow(ele, oldVal) {
      let _this = this;
      let step = (_this.value * 10) / (_this.time * 1000);
      let start = 0;
      if (oldVal) {
        start = oldVal;
      } else {
        start = 0;
      }
      let current = 0;
      let t = setInterval(function() {
        start += Math.ceil(step);
        if (start > _this.value) {
          clearInterval(t);
          start = _this.value;
          t = null;
        }
        if (current === start) {
          return;
        }
        current = start;
        ele.innerHTML = current
          .toString()
          .replace(/(\d)(?=(?:\d{3}[+]?)+$)/g, "$1,");
      }, 10);
    }
  },
  mounted() {
    setTimeout(() => {
      this.numberGrow(this.$refs.numberGrow);
    }, 500);
  },
  watch: {
    value: function(newVal, oldVal) {
      this.numberGrow(this.$refs.numberGrow, oldVal);
    }
  }
};
</script>
<style>
.number-grow-warp {
  transform: translateZ(0);
  display: inline-block;
}
.number-grow {
  font-size: 28px;
  color: #541115;
  font-weight: normal;
  margin-bottom: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/donation/numScroll.vue